export const ACTIONS = {
  LOADING: "Loading",
  COMPLETE: "Complete",
  ERROR: "Error",
  CANCELLED: "Cancelled",
  RESET: "Reset"
}
